export enum LocationTypeEnum {
  Approximate = 'approximate',
  Strict = 'strict',
  Unknown = 'unknown'
}
